import { Pipe, PipeTransform } from '@angular/core';
import { ICueNavChild } from '@cue-core';

@Pipe({ name: 'onlyHref' })
export class OnlyHrefPipe implements PipeTransform {
  transform(value: ICueNavChild[]) {
    return value.filter(n => n.item && !!n.item.href);
  }
}
